"use strict";
var fieldDirective = function($parse) {
  return {
    restrict: 'E',
    scope: true,
    templateUrl: "documenteditor/templates/field.ng.html",
    transclude: 'element',
    replace: true,
    controller: require('../controllers/fieldCtrl'),
    controllerAs: 'fieldCtrl',
    link: function($scope, element, attrs) {
      $scope.name = $parse(attrs.name)($scope, {});
      $scope.validations = $parse(attrs.validations)($scope, {});
      $scope.readonly = $parse(attrs.readonly)($scope, {});
      if ($scope.name == null) {
        $scope.name = attrs.name;
      }
      $scope.element = attrs.$$element;
    }
  };
};
fieldDirective.$inject = ['$parse'];
module.exports = fieldDirective;
